import { Link } from "react-router-dom";
import { categoryGroups } from "@/mocks/categories";

const friendLinks = ["光影放映厅", "短剧观察", "独立影像志", "声音现场"];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="page-shell py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1.1fr] lg:gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                逼特逼视频
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              汇聚热门电影、口碑电视剧与丰富短视频，用清晰的分类、顺手的搜索和舒适的观看界面，
              让每一次打开都有值得看的内容。
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-bilibili-line", label: "哔哩哔哩" },
                { icon: "ri-mail-line", label: "邮件" },
              ].map((item) => (
                <span
                  key={item.icon}
                  title={item.label}
                  aria-label={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-400"
                >
                  <i className={`${item.icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.18em] text-foreground-500">
              快速导航
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { label: "首页推荐", to: "/" },
                { label: "电影频道", to: "/category/movie" },
                { label: "电视剧频道", to: "/category/series" },
                { label: "短视频频道", to: "/category/short" },
                { label: "站内搜索", to: "/search" },
                { label: "关于我们", to: "/about" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-foreground-700 transition-colors hover:text-primary-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.18em] text-foreground-500">
              内容分类
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categoryGroups.map((group) => (
                <li key={group.type}>
                  <Link
                    to={`/category/${group.type}`}
                    className="text-foreground-700 transition-colors hover:text-primary-400"
                  >
                    {group.name}
                  </Link>
                </li>
              ))}
              {categoryGroups[0].subcategories.slice(0, 2).map((sub) => (
                <li key={sub.id}>
                  <Link
                    to={`/list/${sub.id}`}
                    className="text-foreground-700 transition-colors hover:text-primary-400"
                  >
                    {sub.name}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.18em] text-foreground-500">
              联系我们
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              内容合作、版权反馈或产品建议，都欢迎随时来信。
            </p>
            <p className="mt-3 font-label text-sm text-foreground-900">hello@bitbi.video</p>
            <p className="mt-1 text-xs text-foreground-500">工作日 10:00 - 19:00 回复</p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-400/60 px-3.5 py-2 text-xs text-primary-400 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              提交反馈
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 逼特逼视频 · 本站内容仅用于界面演示，播放为前端模拟效果</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="whitespace-nowrap">友情链接</span>
            {friendLinks.map((name) => (
              <span key={name} className="whitespace-nowrap text-foreground-600">
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}